import { GenericObject } from '@dxb-web-ui-framework/common/types';

/**
 *
 * A function to access and assign to the default value of a specified
 *  field the proloaded data value with the corresponding key value
 *
 * @param {GenericObject} field holds the configuration of the specified field
 * @param {GenericObject} data the object that holds the preloaded data key-value pairs
 */

const recursiveValueAssignmentFromKeyAccess = (field: GenericObject, data: GenericObject) => {
  if (!field.components) {
    if (!field.key) {
      field.defaultValue = data[field.name];
    } else {
      field.defaultValue = data[field.key];
    }
  } else {
    field.components.forEach((field: GenericObject) => recursiveValueAssignmentFromKeyAccess(field, data));
  }
};

export { recursiveValueAssignmentFromKeyAccess };
